export const createIconSetFromIcoMoon = () => () => null;
export const createIconSet = () => () => null;

export default () => null;
